import TourOutlinedIcon from '@mui/icons-material/TourOutlined'
import { Button, IconButton, Tooltip, useMediaQuery } from '@mui/material'
import useDemoTour from './useDemoTour'

/**
 * "Take the tour" in the top bar, shown only in demo orgs. Also hosts the
 * tour's auto-start, since the top bar stays mounted across pages.
 */
export default function DemoTourButton() {
    const { canTour, startTour } = useDemoTour()
    const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'))

    if (!canTour) return null

    return (
        <Tooltip title="A two-minute guided tour of this demo">
            {mdUp ? (
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<TourOutlinedIcon />}
                    onClick={startTour}
                    sx={{ whiteSpace: 'nowrap' }}
                >
                    Take the tour
                </Button>
            ) : (
                <IconButton aria-label="Take the tour" onClick={startTour}>
                    <TourOutlinedIcon />
                </IconButton>
            )}
        </Tooltip>
    )
}
